import React, { useState, useEffect } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../../../context/AuthContext';
import Swal from 'sweetalert2';
import axios from "axios";
import QuestionContents from './UI/QuestionContents';
import { useParams } from "react-router-dom";
import ReactPlayer from 'react-player';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import './matchcss.css';

const Choice = (props) => {
    const { t } = useTranslation();
    const [msg, setMsg] = useState([]);
    const [question, setQuestion] = useState([]);
    const [answers, setAnswers] = useState([]);
    const { user } = useAuth();
    const params = useParams();
    const [questionTitle, setQuestionTitle] = useState([]);
    const [questionText, setQuestionText] = useState([]);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [subjectName, setSubjectName] = useState("");
    const ATTEMPT_KEY = `choice_attempt_${props.questionNumber}`;

    const getSubject = async () => {
        try {
            const headerss = {
                accept: "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                Authorization: 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/GetSubject";
            await axios.get(url, { headers: headerss }).then(res => {
                if (res.data.success) {
                    setSubjectName(
                        res.data.data.subjects[params.subjectid - 1].subjectName +
                        " - " +
                        res.data.data.subjects[params.subjectid - 1].subjectDesc
                    );
                }
            });
        } catch (err) { }
    };

    /* ===================== CUSTOM + RESPONSIVE CSS ===================== */
    const customAudioStyle = `
    .rhap_volume-controls,
    .rhap_additional-controls,
    .rhap_repeat-button,
    .rhap_skip-button,
    .rhap_rewind-button,
    .rhap_forward-button,
    .rhap_volume-button {
        display: none !important;
    }

    .option-box {
        border: 2px solid #7ac1f7ff;
        border-radius: 10px;
        padding: 10px;
        transition: 0.2s;
        cursor: pointer;
    }

    .option-box.active {
        border-color: #007bff;
        background-color: #e6f0ff;
        box-shadow: 0 0 10px rgba(0, 123, 255, 0.4);
    }

    .custom-player {
        margin: auto;
        width: 60px !important;
        height: 60px !important;
        display: flex;
        flex-direction: column;
        align-items: center;
        border: none !important;
        box-shadow: none !important;
        background-color: transparent !important;
    }

    .custom-player .rhap_play-pause-button {
        font-size: 40px !important;
        color: blue !important;
    }

    .custom-player .rhap_progress-section {
        display: none !important;
    }

    /* ===== MOBILE OPTIMIZATION ===== */
    @media (max-width: 768px) {

        .question-text {
            font-size: 15px !important;
        }

        .answers-grid {
    padding-bottom: 60px; /* fixed bar nefes alanı */
        }

        .option-box {
            width: 150px !important;
            height: 200px !important;
            padding: 8px !important;
        }

        .custom-player {
            width: 48px !important;
            height: 48px !important;
        }

        .custom-player .rhap_play-pause-button {
            font-size: 32px !important;
        }
            .listen-text {
    font-size: 14px !important;
  }
     .answers-grid::after {
    content: "";
    display: block;
    height: 40px;
  }
    }
    `;

    const Request = async (userAnswer) => {
        try {
            const headerss = {
                accept: "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                Authorization: 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/Answer";
            await axios.get(url, {
                params: {
                    questionId: parseInt(props.questionNumber),
                    answer: userAnswer.toString()
                },
                headers: headerss
            }).then(res => {
                localStorage.removeItem(ATTEMPT_KEY);

                if (res.data.success) {
                    new Audio("https://api.heryerdeingilizce.com/sound/d6350096-7457-46bc-bcaa-313a33970558.mp4").play();
                    Swal.fire({
                        title: "Başarılı!",
                        icon: "success",
                        timer: 3000,
                    }).then(() => {
                        window.location.href =
                            "/user/course/question/" +
                            params.subjectid + "/" +
                            (Number(params.id) + 1);
                    });
                } else {
                    new Audio("https://api.heryerdeingilizce.com/sound/f174007c-0602-4455-8463-ae6a3285f02c.mp4").play();
                    Swal.fire({
                        title: "Hatalı cevap",
                        text: res.data.message,
                        icon: "error",
                    }).then(() => {
                        window.location.href =
                            "/user/course/question/" +
                            params.subjectid + "/" +
                            (Number(params.id) + 1);
                    });
                }
            });
        } catch (err) {
            setMsg(err.message);
        }
    };

    const answerChoiceHandle = (e) => {
        e.preventDefault();
        const attempt = parseInt(localStorage.getItem(ATTEMPT_KEY));
        const correctAnswer = Number(props.data.answer);

        if (attempt === 0) {
            if (selectedAnswer === correctAnswer) {
                Request(selectedAnswer);
            } else {
                localStorage.setItem(ATTEMPT_KEY, "1");
                new Audio("https://api.heryerdeingilizce.com/sound/f174007c-0602-4455-8463-ae6a3285f02c.mp4").play();
                Swal.fire({
                    title: "Tekrar Deneyiniz!",
                    text: props.data.notfyText,
                    icon: "warning",
                }).then(() => window.location.reload());
            }
            return;
        }
        Request(selectedAnswer);
    };

    useEffect(() => {
        if (localStorage.getItem(ATTEMPT_KEY) === null) {
            localStorage.setItem(ATTEMPT_KEY, "0");
        }
        return () => localStorage.removeItem(ATTEMPT_KEY);
    }, [ATTEMPT_KEY]);

    useEffect(() => {
        getSubject();
        const questionn = JSON.parse(props.data.contentStr);
        setQuestion(questionn);
        setQuestionTitle(questionn.text.split('__')[0]);
        setQuestionText(questionn.text.split('__')[1]);
        setAnswers(JSON.parse(props.data.detail));
    }, []);

    return (
        <div>
            <style>{customAudioStyle}</style>

            <span style={{ color: "black" }}>
                <b><i>{subjectName}</i></b>
            </span>

            <br />

            <div style={{ textAlign: "center" }}>
                <QuestionContents question={question} />

                <b className="listen-text" style={{ fontSize: "18px" }}>
                    {questionTitle}
                </b>

                <br />
                {questionText ? (
                    <div>  <br />
                        <b className="question-text" style={{ fontSize: "30px", color: "black" }}>
                            {questionText}
                        </b></div>
                ) : null}


                <br />
            </div>

            <form onSubmit={answerChoiceHandle}>
                <div
                    className="answers-grid"
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        gap: "20px",
                        textAlign: "center"
                    }}
                >
                    {answers.map((dt, index) => (

                        <div
                            key={dt.id}
                            onClick={() => setSelectedAnswer(index)}
                            className={`option-box ${selectedAnswer === index ? "active" : ""}`}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                width: "200px",
                                height: "200px",
                                maxWidth: "100%",
                                borderRadius: 10,
                                padding: "10px",
                                boxShadow: "0 0 8px rgba(0,0,0,0.05)"
                            }}
                        >
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>


                                {(dt.photo || dt.video || dt.sound) ? (
                                    <div style={{
                                        width: "100%",
                                        height: "200px",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>
                                        {dt.photo && <img src={dt.photo} alt="choice" style={{ width: "100%", height: "100%", objectFit: "contain" }} />}
                                        {dt.video && <ReactPlayer url={dt.video} width="100%" height="100%" controls />}
                                        {dt.sound && <AudioPlayer src={dt.sound} className="custom-player" />}
                                    </div>
                                ) : (<div style={{ marginBottom: "10px", fontWeight: "bold" }}>{dt.service}</div>)}
                            </div>
                        </div>
                    ))}
                </div>

                <br />

                {
                    !props.answered && (
                        <div className="d-flex justify-content-center">
                            <button type="submit" className="save-btn">
                                {t("saveAndContinue")}
                            </button>
                        </div>
                    )
                }
            </form >
        </div >
    );
};

export default Choice;
